import { pdf } from "@react-pdf/renderer";
import DownloadArquivo from "./DownloadArquivo";

export default async function PDF({ documento }) {
  const documentoPdf = pdf(documento);
  const blob = await documentoPdf.toBlob();

  return {
    AbrirArquivo: () => {
      const url = window.URL.createObjectURL(blob);
      window.open(url);
    },
    DownloadArquivo: () => {
      DownloadArquivo(blob, "nome_pdf.pdf");
    },
    GetBlob: () => {
      return blob;
    },
  };
}
